<template>
  <div class="adnBox">
    <img src="../../assets/images/close.png" class="close" alt="" @click="showClose">
    <div class="animation">
      <img style="width:18px;margin-right:5px" src="../../assets/images/notice.png" alt="">
      <div class="text-container">
        <span>最新消息：</span>
        <transition class="inner-container" name="slide" mode="out-in">
          <p class="text2" :key="newsText.id" @click="link(newsText.item)">
            {{this.getNewName(newsText.val)}}
          </p>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { zhiboBanner } from '../../../../../../api/info.js';
import { queryBrandImgList } from '@/apis/common'
import { getBannerJumpUrl } from '@/utils/activityUrl'


export default {
  name:'advertNotice',
  data(){
    return{
      news: [
      ],
      number: 0,
      imgurl:'',
    }
  },
  created(){
    this.init();
  },
  mounted(){
    this.startMove();
  },
  computed:{
    newsText() {
      return {
        id: this.number,
        val: this.news[this.number] ? this.news[this.number].name : '',
        url: this.news[this.number] ? this.news[this.number].url : '',
        item: this.news[this.number] || null,
      }
    }
  },
  methods:{
    // 关闭提示信息
    showClose(){
            this.$store.commit('home/set_showNotice', false)

    },
    // 获取swiper
    init(){
      const option = {
        languageidentification:1,
        type:39,
        region:1,
        brandId: '49',

      }
      // queryBrandImgList(option).then(res => {
      //   if (res && res.length > 0) {
      //     this.news = res;


      //   } else {
      //     this.news = res[0]

      //   }
      // }).catch(err => {
      //   console.log(err);
      // })
      zhiboBanner(option).then(res=>{
        if(res.Status === 0){
          this.news = res.Data;
        }
      }).catch(err=>{
        console.log(err);
      })
    },
    // 在定时器中不断改变计算属性对应的值
    startMove() {
      this.number = 0;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.number < this.news.length - 1) {
          this.number += 1;
        } else {
          this.number = 0;
        }
      }, 4000);
    },
    // 跳转链接
    async link(item){
      const attr = await getBannerJumpUrl(item);
      if(attr){
        window.open(attr);
      }
    },
    // 处理只显示十个字符，其他的用...代替
    getNewName(name) {
      var len = 0;
      var reallen = 0;
      for (var j=0; j<name.length; j++) {
        if (name.charCodeAt(j)>127 || name.charCodeAt(j)==94) {
          len += 1;
        } else {
          len ++;
        }
        if(len<22){
          reallen++;
        }
      }
      if (len >= 22) {
        name = name.substr(0,reallen)+'···';
      }
      return name;
    },
  }
}
</script>

<style lang="less" scoped>
.adnBox{
  width: 100%;
  height: 38px;
  box-sizing: border-box;
  padding-left: 10px;
  position: relative;
  .close{
    width: 14px;
    height: 14px;
    position: absolute;
    top: 6px;
    right: 18px;
  }
  .animation{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .text-container{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      span{
        color: #2C3EB9;
      font-size: 12px;
      line-height: 17px;
      font-weight: 500;
        margin: 0 5px;
      }
      .slide-enter-active, .slide-leave-active {
        transition: all 0.2s linear;
      }
      .slide-leave-to {
        transform: translateY(-10px);
      }
      .slide-enter {
        transform: translateY(10px);
      }
      .text2{
        color: #f81421;
        cursor: pointer;
        font-size: 15px;
      }
    }
  }
}
</style>